
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLinkRemove as ObiLinkRemoveElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-link-remove.js';
 
 
 

 
 export const ObiLinkRemove = createComponent({
   react: React,
   tagName: 'obi-link-remove',
   elementClass: ObiLinkRemoveElement,
   events: {
     
   }
  });
 
 